module.exports = __webpack_public_path__ + "img/H01122-74.9be04808.jpg";